export default "__VITE_ASSET__CxdHpbLE__"